import React from 'react';
import LoyiaInlineIcon from './LoyiaInlineIcon';
import './LoyiaMain.css';

const LoyiaMain = () => {
  return (
    <div className="loyia-wrap">
      <main className="main">
        <p className="desc">
          Loyia est votre analyste métier privé&nbsp;: une intelligence souveraine conçue pour
          explorer l'ensemble de l'écosystème Langloys pour vous délivrer des réponses
          précises, sourcées et strictement confidentielles. Elle vous offre un accès interactif
          et sécurisé à tout notre savoir-faire opérationnel.
        </p>

        <div className="avatar-section">
          <div className="avatar">
            <LoyiaInlineIcon size={56} className="loyia-main-avatar-icon" />
          </div>

          <div className="greeting">
            <p className="hello">Bonjour,</p>
            <p className="question">
              LOYIA prépare son arrivée&nbsp;: votre assistant métier intelligent sera bientôt
              disponible pour vous accompagner dans vos recherches et vos analyses.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LoyiaMain;
